import countryListData from "@/common/data.js";
import { isObject } from "lodash";

/**
 * 根据国家代码返回对应的语言代码
 * 对应关系：
 * - 中国 → 简体中文 (zh)
 * - 港澳台 → 繁体中文 (cht)
 * - 日本 → 日语 (jp)
 * - 韩国 → 韩文 (kor)
 * - 印度尼西亚 → 印尼语 (hi)
 * - 北美(美国/加拿大) → 英文 (en)
 * - 墨西哥及拉美国家 → 西班牙语 (spa)
 * - 阿拉伯相关国家→ 阿拉伯语 (ar)
 * - 其他国家 → 默认英文 (en)
 */
export const countryToLanguage = (code) => {
  if (!code) return "en";

  const countryCode = code.toLowerCase();

  // 根据国家代码映射对应语言（基于项目实际使用的语言代码）
  const countryLanguageMap = {
    // 中国 - 简体中文
    cn: "zh",

    // 港澳台 - 繁体中文
    hk: "cht",
    mo: "cht",
    tw: "cht",

    // 日本 - 日语
    jp: "jp",

    // 韩国 - 韩文
    kr: "kor",

    // 印度尼西亚 - 印尼语
    id: "id",

    // 北美 - 英文
    us: "en",
    ca: "en",
    // 墨西哥及其他西语国家 - 西班牙语
    mx: "spa",
    es: "spa",
    ar: "spa",
    cl: "spa",
    co: "spa",
    pe: "spa",
    // 阿拉伯相关国家→ 阿拉伯语
    sa: "ara",
  };
  return countryLanguageMap[countryCode] || "en";
};

export const countryToCountry = (code) => {
  return countryListData.countryListData.find((item) => {
    return item?.code?.toUpperCase() === code?.toUpperCase();
  });
};

/** 获取请求后边的参数 */
export const getUrlParams2 = (url) => {
  const urlStr = url.split("?")[1];
  const urlSearchParams = new URLSearchParams(urlStr);
  const result = Object.fromEntries(urlSearchParams.entries());
  return result;
};

export const getFileNameByUrl = (url) => {
  const urlObj = url ? new URL(url) : null;
  if (urlObj) {
    const { pathname = "" } = urlObj;
    return pathname.substring(pathname.lastIndexOf("/") + 1);
  }
  return "";
};

const imgList = [
  "png",
  "jpg",
  "jpeg",
  "bmp",
  "gif",
  "tif",
  "webp",
  "apng",
  "svg",
]; //图片文件的后缀名
const videoList = [
  "mp4",
  "m2v",
  "mkv",
  "rmvb",
  "wmv",
  "avi",
  "flv",
  "mov",
  "m4v",
];
const radioList = ["mp3", "wav", "wmv"];

const getFileSuffix = (fileName) => {
  let suffix = "";

  if (fileName) {
    const flieArr = fileName.split("?")[0].split(".");
    suffix = flieArr[flieArr.length - 1];
  }

  if (!suffix) return "";
  suffix = suffix.toLocaleLowerCase();
  return suffix;
};
export const getFileType = (fileName) => {
  const suffix = getFileSuffix(fileName);

  if (!suffix) return "";

  if (imgList.includes(suffix)) {
    return "image";
  }
  if (videoList.includes(suffix)) {
    return "video";
  }
  if (radioList.includes(suffix)) {
    return "radio";
  }

  // 可能是没有拿到后缀的情况
  if (suffix.length > 10) {
    const query = fileName.split("?")[1];
    if (query) {
      if (query.includes("image")) {
        return "image";
      }
      // FIX: 音频 / 视频 query 参数待定，没有找到对应的文件
      if (query.includes("video")) {
        return "video";
      }
      if (query.includes("radio")) {
        return "radio";
      }
    }
  }

  // FIX: 扩展其他类型
  return "other";
};
export const getUuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const buildQueryParams = (params, options = {}) => {
  const {
    skipEmpty = false, // 是否跳过空值
    separator = "&", // 分隔符
  } = options;

  return Object.entries(params)
    .filter(
      ([_, value]) =>
        !skipEmpty || (value !== undefined && value !== null && value !== "")
    )
    .map(([key, value]) => (value ? `${key}=${value}` : `${key}=`))
    .join(separator);
};

// 判断是否为移动端
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|arkweb|harmonyos|openharmony|HarmonyOS/i.test(
    navigator.userAgent
  );
};
